<template>
  <div class="search-administrators container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card" v-if="log" style="border-radius: 4px; box-shadow: 0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);">
          <div class="card-body" style="padding: 0 !important;">
            <div style="padding: 1.25rem;">
              <span style="font-size: 1.3rem; font-weight: 400;">{{log.request_method}}</span>
              <span style="font-size: 1.3rem">{{log.url_full}}</span>
              <span :style="'border-radius: 20px; padding-right: 8px; padding-left: 8px; transform: translateY(-2.82px);' + (log.response_status_code < 400 ? 'background-color: #cbf4c9;' : 'background-color: red;')">{{log.response_status_code}}</span>
            </div>
            <div style="width: 100%; background-color: #f7fafc; box-shadow: inset 0 1px #e3e8ee; padding: 1.25rem;">
              <table>
                <colgroup>
                  <col span="1" style="width: 40%;">
                  <col span="1" style="width: 100%;">
                </colgroup>
                <tbody>
                <tr>
                  <td>Created at</td>
                  <td>{{ moment(log.created_at).format("MMMM Do, YYYY \\at h:mm a")  + " (" + moment.tz.guess() + ")" }}</td>
                </tr>
                <tr>
                  <td>IP</td>
                  <td>{{ log.ip }}</td>
                </tr>
                <tr>
                  <td>Platform</td>
                  <td>{{ log.platform ? log.platform : 'N/A' }}</td>
                </tr>
                <tr>
                  <td>APP version</td>
                  <td>{{ log.app_version ? log.app_version : 'N/A' }}</td>
                </tr>
                <tr>
                  <td>Time spent</td>
                  <td>{{ (log.time_spent/1000).toFixed(2) + 's' }}</td>
                </tr>
                <tr>
                  <td>User</td>
                  <td>
                    <div v-if="log.id_user">
                      <router-link :to="'/users/' + log.id_user.id_user + '/'">
                        {{ log.id_user.name_first + ' ' + log.id_user.name_last }}
                      </router-link>
                    </div>
                    <div v-else>
                      Anonymous User
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card" v-if="log" style="border-radius: 4px; box-shadow: 0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);">
          <div class="card-body" style="padding: 0 !important;">
            <div style="padding: 1.25rem;">
              <span style="font-size: 1rem">Request header</span>
            </div>
            <div style="width: 100%; background-color: #f7fafc; box-shadow: inset 0 1px #e3e8ee; padding: 1.25rem;">
              <div v-if="log.request_header">
                <json-viewer :value="log.request_header"
                             :expand-depth=5
                             copyable></json-viewer>
              </div>
              <div v-else>
                <span>N/A</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card" v-if="log" style="border-radius: 4px; box-shadow: 0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);">
          <div class="card-body" style="padding: 0 !important;">
            <div style="padding: 1.25rem;">
              <span style="font-size: 1rem">Request body</span>
            </div>
            <div style="width: 100%; background-color: #f7fafc; box-shadow: inset 0 1px #e3e8ee; padding: 1.25rem;">
              <div v-if="log.request_body">
                <json-viewer :value="log.request_body"
                             :expand-depth=5
                             copyable></json-viewer>
              </div>
              <div v-else>
                <span>N/A</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card" v-if="log" style="border-radius: 4px; box-shadow: 0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);">
          <div class="card-body" style="padding: 0 !important;">
            <div style="padding: 1.25rem;">
              <span style="font-size: 1rem">Response body</span>
            </div>
            <div style="width: 100%; background-color: #f7fafc; box-shadow: inset 0 1px #e3e8ee; padding: 1.25rem;">
              <div v-if="validateString(log.response_body)">
                <span>{{log.response_body}}</span>
              </div>
              <div v-else>
                <json-viewer :value="log.response_body"
                             :expand-depth=5
                             copyable></json-viewer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card" v-if="log" style="border-radius: 4px; box-shadow: 0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);">
          <div class="card-body" style="padding: 0 !important;">
            <div style="padding: 1.25rem;">
              <span style="font-size: 1rem">Device info</span>
            </div>
            <div style="width: 100%; background-color: #f7fafc; box-shadow: inset 0 1px #e3e8ee; padding: 1.25rem;">
              <div v-if="log.device_info">
                <json-viewer :value="log.device_info"
                             :expand-depth=5
                             copyable></json-viewer>
              </div>
              <div v-else>
                <span>N/A</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card" v-if="log" style="border-radius: 4px; box-shadow: 0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);">
          <div class="card-body" style="padding: 0 !important;">
            <div style="padding: 1.25rem;">
              <span style="font-size: 1rem">Phone settings</span>
            </div>
            <div style="width: 100%; background-color: #f7fafc; box-shadow: inset 0 1px #e3e8ee; padding: 1.25rem;">
              <div v-if="log.phone_settings">
                <json-viewer :value="log.phone_settings"
                             :expand-depth=5
                             copyable></json-viewer>
              </div>
              <div v-else>
                <span>N/A</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  import JsonViewer from 'vue-json-viewer'
  Vue.use(JsonViewer)

  export default {
    metaInfo: {
      title: 'Wingz Support | Request Log',
    },
    name: 'RequestLog',
    data () {
      return {
        title: 'Request Log',
        previousAdmin: null,
        data: {},
        log: null,
        email: '',
        name_first: null,
        name_last: null,
        password: null,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        roles: [],
        role: 'admin',
        input_admin:null,
        errors: null,
        non_field_errors: null,
        field_name: {
          'name_first': 'First Name',
          'name_last': 'Last Name',
          'password': 'Password',
          'email': 'Email',
        },
        email_bk: null,
        name_first_bk: null,
        name_last_bk: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      validateString(str) {
        return (typeof str === 'string' || str instanceof String)
      },
      validateJson(key) {
        console.log('validate ' + key)
        console.log('validate ' + this.log[key])
          if (!this.log[key]) return false
          try {
            this.log[key] = JSON.parse(this.log[key])
            return true
          } catch (e) {
            return false
          }
      },
      changePreviousAdmin(admin) {
        if (this.previousAdmin) {
          this.previousAdmin.edit = false
        }
        this.previousAdmin = admin
      },
      search: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'request-logs/' + this.$route.params.id + '/')
          .then(response => {
            console.log(response.data)

            this.log = response.data
            this.validateJson('request_header')
            this.validateJson('request_body')
            this.validateJson('response_body')
            this.validateJson('phone_settings')
            this.validateJson('device_info')
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      buttonSearch (page) {
        this.resetPager()
        this.search(page)
      },
      changePage: function (page) {
        console.log('change to page: ' + page)
        this.search(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      backup(admin) {
        this.email_bk = admin.email
        this.name_first_bk = admin.name_first
        this.name_last_bk = admin.name_last
      },
      restore(admin) {
        if (!admin) {
          return
        }
        admin.name_first = this.name_first_bk
        admin.name_last = this.name_last_bk
        admin.email = this.email_bk
      },
      updateAdmin(admin) {
        // partial update
        this.isLoading = true
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'users/' + admin.id_user + '/?type=update_admin', {
            email: admin.email.replace('\n', '').trim(),
            name_first: !admin.name_first ? '' : admin.name_first.replace('\n', '').trim(),
            name_last: !admin.name_last ? '' : admin.name_last.replace('\n', '').trim(),
          })
          .then(response => {
            console.log(response.data)

            this.backup(response.data)

            admin.edit = false
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)

            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              if (Array.isArray(error)) {
                error = error[0]
              } else {
                let name = Object.keys(error)[0]
                error = error[name][0].replace('This field', this.field_name[name])
                error = error.replace('this field', this.field_name[name])
                error = error.replace('Enter a valid email address.', 'Invalid email address.')
              }
            }

            this.showToastError(error)
          })
          .finally(() => this.isLoading = false)
      },
      addAdmin() {
        // if (this.email.indexOf('@') == -1 || this.email.indexOf('.') == -1) {
        //   alert('please enter a valid email')
        //   return
        // }

        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL_CS + 'users/?type=create_admin', {
            email: this.email,
            name_first: this.name_first,
            name_last: this.name_last,
            password: this.password,
            is_admin: this.role == 'admin',
            is_agent: this.role == 'agent'
          })
          .then(response => {
            console.log(response.data)

            this.email = ''
            this.name_first = ''
            this.name_last = ''
            this.password = ''

            // update list
            this.search()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)

            this.isLoading = false

            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              let name = Object.keys(error)[0]
              error = error[name][0].replace('This field', this.field_name[name])
              error = error.replace('this field', this.field_name[name])
              error = error.replace('Enter a valid email address.', 'Invalid email address.')
            }

            this.showToastError(error)
          })
      },
      changeRole(admin, index) {
        // partial update
        this.isLoading = true
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'users/' + admin.id_user + '/?type=update_admin_role', {
            is_admin: this.roles[index] == 'admin',
            is_agent: this.roles[index] == 'agent'
          })
          .then(response => {
            console.log(response.data)
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      deleteAdmin(admin) {
        if(!confirm("Are you sure you want to remove this user?")) {
          return
        }

        this.isLoading = true
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'users/' + admin.id_user + '/?type=delete_admin', {})
          .then(response => {
            console.log(response.data)

            // update list
            this.search()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
            this.errored = true
            this.isLoading = false
          })
      }
    },
    mounted () {
      console.log("Mounted")
      this.search()
    },
    created () {
      // document.title = "Wingz Support | Settings";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }

  .add-admin-btn {
    color: #333268;
    background-color: #00f9b9;
    border: none;
    margin-left: 5px;
  }

  .add-admin-btn:hover {
    background-color: red;
  }

  .add-admin-panel {
    max-width: 400px;
  }
  .form-check {
    display: inline-block;
    padding-left: 0px;
    padding-right: 10px;
  }

  .jv-container {
    background-color: #f7fafc !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/RequestLogs.vue